export default () => {
    return {
        animating: false,
        ministryAnimating: false,
        ministryHover: false,
        ministryHovered: 'foundation',
        closeEverything: false,

        // π ----
        // :: MOUNTED ---------------------------::
        // ____
        mounted() {
            gsap.set(this.$refs.menuBase01, { yPercent: 104 })
            gsap.set(this.$refs.menuBase02, { yPercent: 104 })
            gsap.set(this.$refs.redline, { yPercent: 104 })

            if (this.$refs.mediaBase) {
                gsap.set(this.$refs.mediaBase, { yPercent: 104 })
            }

            if (this.$refs.ministryBase01) {
                gsap.set(this.$refs.ministryBase01, { yPercent: 104 })
                gsap.set(this.$refs.ministryBase02, { yPercent: 104 })
            }

            this.$watch('$store.nav.open', value => this.open(value))
            this.$watch('$store.nav.ministry', value => this.openMinistries(value))
            this.$watch('$store.nav.ministryClose', value => this.closeMinistries(value))
        },

        // π ----
        // :: OPEN ---------------------------::
        // ____
        open(isOpen) {
            if (isOpen) {
                document.body.classList.add('no-scroll');
                this.animating = true;

                const openMenu = gsap.timeline({
                    onComplete: () => {
                        this.animating = false;
                    }
                });

                openMenu
                    .fromTo(
                        this.$refs.menuBase01,
                        { yPercent: 104 },
                        { duration: 0.6, yPercent: 0, ease: 'circ.inOut' }
                    )
                    .fromTo(
                        this.$refs.menuBase02,
                        { yPercent: 104 },
                        { duration: 0.6, yPercent: 0, ease: 'circ.inOut' },
                        '>-0.5'
                    )
                    .to(this.$refs.menuWrapper, { duration: 0.3, autoAlpha: 1 })
                    .addLabel('content');

                /* :: If Ministry Nav Media
                {+} ---------------------------------- */
                if (this.$refs.mediaWrapper) {
                    openMenu
                        .fromTo(
                            this.$refs.mediaBase,
                            { yPercent: 104 },
                            { duration: 0.6, yPercent: 0, ease: 'circ.inOut' },
                            '>-0.6'
                        )
                        .to(this.$refs.mediaWrapper, { duration: 0.3, autoAlpha: 1 });
                }

                openMenu
                    .fromTo(
                        this.$refs.redline,
                        { yPercent: 104 },
                        { duration: 0.5, yPercent: 0, ease: 'circ.inOut' },
                        'content-=0.8'
                    )
                    .to(this.$refs.footer, { duration: 0.3, autoAlpha: 1 }, 'content')
                    .to(this.$refs.button, { duration: 0.3, autoAlpha: 1 }, 'content');
            }
        },

        // π ----
        // :: CLOSE ---------------------------::
        // ____

        /* :: Preflight
        {+} ---------------------------------- */
        closePreflight() {
            if ($store.nav.open && !this.animating) {
                this.animating = true;

                if ($store.nav.ministry && !this.ministryAnimating) {
                    $store.nav.ministryClose = true;
                    this.closeEverything = true;
                } else {
                    this.close();
                }
            }
        },

        /* :: Close
        {+} ---------------------------------- */
        close() {
            const closeMenu = gsap.timeline({
                onComplete: () => {
                    this.animating = false;
                    this.$store.nav.open = false;
                    document.body.classList.remove('no-scroll');
                }
            });

            closeMenu
                .addLabel('start')
                .to(this.$refs.button, { duration: 0.3, autoAlpha: 0 })
                .to(this.$refs.footer, { duration: 0.3, autoAlpha: 0 }, 'start')
                .to(this.$refs.menuWrapper, { duration: 0.3, autoAlpha: 0 }, 'start');

            if (this.$refs.mediaWrapper) {
                closeMenu.to(this.$refs.mediaWrapper, { duration: 0.3, autoAlpha: 0 }, 'start+=0.3');
            }

            closeMenu
                .to(this.$refs.redline, { duration: 0.4, yPercent: -104, ease: 'circ.inOut' }, 'start+=0.1')
                .to(this.$refs.menuBase02, { duration: 0.6, yPercent: -104, ease: 'circ.inOut' }, 'start+=0.3')
                .to(this.$refs.menuBase01, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' }, 'start+=0.5');

            if (this.$refs.mediaWrapper) {
                closeMenu.to(this.$refs.mediaBase, { duration: 0.5, yPercent: -104, ease: 'circ.inOut' }, 'start+=0.7');
            }
        },

        // π ----
        // :: MINISTRIES: OPEN ---------------------------::
        // ____
        openMinistries(isOpen) {
            if (isOpen && !this.ministryAnimating) {
                this.ministryAnimating = true;

                const openMenu = gsap.timeline({
                    onComplete: () => {
                        this.ministryAnimating = false;
                    }
                });

                openMenu
                    .fromTo(
                        this.$refs.ministryBase01,
                        { yPercent: 104 },
                        { duration: 0.6, yPercent: 0, ease: 'circ.inOut' }
                    )
                    .fromTo(
                        this.$refs.ministryBase02,
                        { yPercent: 104 },
                        { duration: 0.6, yPercent: 0, ease: 'circ.inOut' },
                        '>-0.5'
                    )
                    .to(this.$refs.ministryContent, { duration: 0.3, autoAlpha: 1 });
            }
        },

        // π ----
        // :: MINISTRIES: CLOSE ---------------------------::
        // ____
        closeMinistries(isActivated) {
            if (isActivated) {
                if (!this.ministryAnimating) {
                    this.ministryAnimating = true;

                    const closeMenu = gsap.timeline({
                        onComplete: () => {
                            this.ministryAnimating = false;
                            this.$store.nav.ministryClose = false;
                            this.$store.nav.ministry = false;

                            if (this.closeEverything) {
                                this.closeEverything = false;
                                this.close();
                            }
                        }
                    });

                    closeMenu
                        .to(this.$refs.ministryContent, { duration: 0.3, autoAlpha: 0 })
                        .to(this.$refs.ministryBase02, { duration: 0.6, yPercent: 104, ease: 'circ.inOut' }, '>-0.1')
                        .to(this.$refs.ministryBase01, { duration: 0.6, yPercent: 104, ease: 'circ.inOut' }, '>-0.5');
                } else {
                    this.$store.nav.ministryClose = false;
                }
            }
        }
    };
};
